import React, { useEffect, useState, useRef } from "react";
import '../../App.css';
import {
	Avatar, Button, Box, Card, Chip, CircularProgress, ClickAwayListener, FormControl, Grid, IconButton, Input, InputLabel, LinearProgress,
	List, ListItem, ListItemButton, ListItemIcon, ListItemText, Menu, MenuItem, Paper, Popper, 
	Select, Typography, FormControlLabel, Checkbox
} from '@mui/material';
import SentenceTransformAttemptPreview from './sentence-transform-attempt-preview';
import SentenceTransformQSetExercise from "./sentence-transform-qset-exercise";
import OutlinedInput from '@mui/material/OutlinedInput';
import { DateRangePicker } from 'react-date-range';
const dayjs = require("dayjs");

export default function SentenceTransformAttempt({oUser, submitDone, recList, isListLoaded}) {
    const [isLoading, setIsLoading] = useState(false);
    const gradeList = ['P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'S1', 'S2', 'S3', 'S4', 'S4E', 'S5'];
    const [selectedGrade, setSelectedGrade] = useState([]);
    const [filterByDate, setFilterByDate] = useState(false);
    const [startDate, setStartDate] = useState(dayjs().subtract(7, 'day'));
    const [endDate, setEndDate] = useState(dayjs());
    const [dateRange, setDateRange] = React.useState([dayjs().subtract(7, 'day'), dayjs()]);
    const anchorRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [selectedExerciseId, setSelectedExerciseId] = useState([]);
    const [redoWrongOnly, setRedoWrongOnly] = useState(false);
    const [selectedExerciseDetails, setSelectedExerciseDetails] = useState([]);
    const [viewMode, setViewMode] = useState("AGAIN");

    const handleGradeSelect = (arg) => {
        setSelectedGrade(
        typeof arg.target.value === 'string' ? arg.target.value.split(',') : arg.target.value,
        );
    };

    const handleFilterByDate = (event) => {
        setOpen(!filterByDate);
        setFilterByDate(!filterByDate);
    };

    const handleOpenCalendar = () => {
        setOpen(true);
    }
    const handleCloseCalendar = () => {
        setOpen(false);
    }

    const handleTogglePracticeSet = (exerciseId) => () => {
    setSelectedExerciseId((prev) =>
        prev.includes(exerciseId)
        ? prev.filter((id) => id !== exerciseId)
        : [...prev, exerciseId]
    );
    };

    const handleStartClick = (event) => {
        setViewMode("START_REDO");
    };

    const listFilterExercise = ()=>{
        let list = Array.isArray(recList) ? recList : [];

        if (selectedGrade.length > 0) {
            list = list.filter((e) => {
                const g = (e.grade || '').toString().toUpperCase();
                return selectedGrade.includes(g);
            });
        }

        if (filterByDate && startDate && endDate) {
            const start = dayjs(startDate).startOf('day').valueOf();
            const end = dayjs(endDate).endOf('day').valueOf();

            list = list.filter((e) => {
                const ts = dayjs(e.timestampUtc || e.createdAt || e.timestamp).valueOf();
                return !Number.isNaN(ts) && ts >= start && ts <= end;
            });
        }
        list.forEach((r, iR)=>{
			r.hasWrong = r.questionCount == r.questionYCount ? false : true;
		}) 
        
        if (redoWrongOnly) {
            list = list.filter((e) => e.hasWrong == true);
        }

        return list;
    }

    const filteredRecList = React.useMemo(
        () =>
        listFilterExercise()
        ,
        [recList, selectedGrade, filterByDate, startDate, endDate, redoWrongOnly]
    );

    const selectedExercisesDetail = React.useMemo(() => {
        const base = Array.isArray(filteredRecList) ? filteredRecList : [];

        // Take only the exercises the user checked
        const chosen = base.filter(e => selectedExerciseId.includes(e.exerciseId));

        // Flatten questions from pages
        let qs = [];
        chosen.forEach(e => {
            e.pages?.forEach(p => {
            p.questions?.forEach(q => {
                qs.push({
                exerciseId: e.exerciseId,
                pageId: p.pageId,
                questionId: q.questionId,
                originalSentence: q.originalSentence,
                question: q.question,
                status: q.status,
                correctedAnswer: q.correctedAnswer,
                });
            });
            });
        });

        if (redoWrongOnly) {
            qs = qs.filter(q => q.status === 3); // only wrong
        }

        setSelectedExerciseDetails(qs);

        return qs;
    }, [filteredRecList, selectedExerciseId, redoWrongOnly]);

    return(
      <Grid container>
        {viewMode == "AGAIN" && 
            <>
        <Grid item xs={12}>
            <Box sx={{fontWeight:'bold', fontFamily: "'Playpen Sans', cursive", fontSize:'2rem', textAlign:'center'}}>
                Try Again
            </Box>
        </Grid>
        <Grid item xs={12} style={{ textAlign:'center'}}>
            <Typography sx={{fontSize:'1.3rem'}}>Re-attempt question sets</Typography>
        </Grid>

        <Grid container spacing={2} sx={{ marginTop: '1rem' }}>
            {/* left side - filtering */}
            <Grid item xs={6}>
                <Grid item xs={12} sx={{marginLeft: "10px"}}>
                <div>
                    <FormControl sx={{ width: 200 }}>
                        <InputLabel>Select Grade</InputLabel>
                            <Select
                            multiple
                            value={selectedGrade}
                            onChange={handleGradeSelect}
                            input={<OutlinedInput label="Select Grade" />}
                            renderValue={(selected) => {
                                const max = 3;
                                const visible = selected.slice(0, max);
                                const hiddenCount = selected.length - max;
                                return (
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                {visible.map((value) => (
                                    <Chip key={value} label={value} size="small" />
                                ))}
                                {hiddenCount > 0 && (
                                    <Chip label={`+${hiddenCount}`} size="small"/>
                                )}
                                </Box>
                                )
                            }}
                            >
                            {gradeList.map((grade) => (
                                <MenuItem key={grade} value={grade}>
                                <Checkbox checked={selectedGrade.includes(grade)} />
                                <ListItemText primary={grade} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
                </Grid>

                <Grid item xs={12} sx={{ display: 'flex', marginTop: '1rem', marginLeft: "10px"}}>
                    <FormControlLabel ref={anchorRef}
                        control={
                            <Checkbox
                            color="primary"
                            checked={filterByDate}
                            onChange={handleFilterByDate}
                            />}
                            label="Filter by date range"
                            />
                
                    {!open && filterByDate &&
                        <Box 
                        sx={{
                            display: 'flex', 
                            justifyContent: 'flex-end', 
                            gap: 1, 
                            p: 1, 
                            border: 1, 
                            borderColor: 'divider', 
                            borderRadius: 1, 
                            bgcolor: 'background.paper'}}>
                        <Button size="small" onClick={handleOpenCalendar} sx={{color: "rgba(19,130,117,1)"}}>
                            {`${dateRange[0].format('DD/MM/YYYY')} – ${dateRange[1].format('DD/MM/YYYY')}`}
                        </Button>
                        </Box>
                    }
                
                    {filterByDate && 
                        <Popper
                        open={open}
                        anchorEl={anchorRef.current}
                        placement="right-start"
                        style={{ zIndex: 1300 }}>
                        <ClickAwayListener onClickAway={handleCloseCalendar}>
        
                        <Box
                        sx={{
                        boxShadow: 3,
                        bgcolor: 'background.paper',
                        borderRadius: 1,
                        overflow: 'hidden',
                        color: "rgba(19,130,117,1)", 
                        '& .rdrDefinedRangesWrapper': {
                            display: 'none !important',
                        },
                        '& .rdrDateRangeWrapper': {
                            gridTemplateColumns: '0px auto !important',
                        },
                        '& .rdrInRange, & .rdrStartEdge, & .rdrEndEdge, & .rdrSelected': {
                            background: 'rgba(19,130,117,1) !important',
                        },

                        }}
                        >
                        <DateRangePicker  ranges={[{
                        startDate: startDate.toDate(), 
                        endDate: endDate.toDate(), 
                        key: 'selection' }]}
                        onChange={item => {
                            const sel = item.selection;
                            setStartDate(dayjs(sel.startDate));
                            setEndDate(dayjs(sel.endDate));
                            setDateRange([dayjs(sel.startDate), dayjs(sel.endDate)]);}}
                            direction="vertical"
                            months={1}        
                            showDateDisplay={false}
                            maxDate={new Date()}  
                            staticRanges={[]}
                            inputRanges={[]}
                        />
                            
                    <Box sx={{display: 'flex', justifyContent: 'flex-end'}}>
                        <Button size="small" onClick={handleCloseCalendar} sx={{color: "rgba(19,130,117,1)"}}>
                            Close
                        </Button>
                    </Box>
                            
                    </Box>
                    </ClickAwayListener>
                        </Popper>
                    }
                </Grid>  

                <Grid item xs={12} sx={{ display: 'flex', marginBottom: '1rem', marginLeft: "10px"}}>
                    <FormControlLabel ref={anchorRef}
                        control={
                            <Checkbox
                            color="primary"
                            checked={redoWrongOnly}
                            onChange={(e) => setRedoWrongOnly(e.target.checked)}
                            />}
                        label="Only Redo Wrong Question"
                    />
                </Grid>  

    <Grid container xs={12} sx={{marginLeft: "10px"}}>
        <Grid item xs={11}>
            <Paper sx={{ width: '100%', height: 300, overflow: 'auto', p: 0 }}>
            {isLoading || !isListLoaded ? (
                <Box sx={{ p: 2 }}>
                <Typography variant="body2">Loading…</Typography>
                </Box>
            ) : filteredRecList.length != 0 && isListLoaded ? (
                <List dense disablePadding>
                {filteredRecList
                    .map((e) => {
                    const checked = selectedExerciseId.includes(e.exerciseId);
                    return (
                        <ListItem
                        key={e.exerciseId}
                        disablePadding
                        >
                        <ListItemButton onClick={handleTogglePracticeSet(e.exerciseId)}>
                            <ListItemIcon>
                                <Checkbox 
                                edge="start"
                                tabIndex={-1}
                                checked={checked}
                                inputProps={{ 'aria-label': `select ${e.viewTitle}` }}/>
                            </ListItemIcon>
                            <ListItemText
                            primary={ `${e.viewTitle} ${e.questionSetName}` 
                                        || 'Untitled exercise'}
                            />
                            <Box marginRight="auto">
                                {e.grade != 0 && 
                                <Chip label={e.grade}
                                    variant="filled" 
                                    style={{
                                    backgroundColor: 'rgba(19,130,117,1)',
                                    color: "white",
                                    height: '22px', 
                                    marginRight: '5px', 
                                    marginBottom: '3px'
                                    }}
                                    sx={{ fontSize: '.8rem', marginTop: '0rem', marginBottom: '0', padding: '0.1px', maxHeight: "28px", }}
                                />
                                }
                            </Box>

                            {/* Show the score for each exercise set */}
                            <Box marginLeft="auto">
                                <Chip 
                                label={e.scoreTitle}
                                variant="filled" 
                                style={{
                                    backgroundColor: 'rgba(19,130,117,1)',
                                    color: "white", 
                                    height: '22px', 
                                    marginBottom: '3px'
                                }} 
                                    sx={{ fontSize: '.8rem', marginTop: '0rem', marginBottom: '0', padding: '0.1px', maxHeight: "28px", }}
                                />
                            </Box>

                        </ListItemButton>
                        </ListItem>
                    );
                    })}
                </List>
            ) : (
                <Box sx={{ p: 2 }}>
                <Typography variant="body2">No Exercise Set Available</Typography>
                </Box>
            )}
            </Paper>

            <Box sx={{ mt: 1 }}>
                <Typography variant="caption">
                    Total Questions Selected: {selectedExerciseDetails.length}
                </Typography>
            </Box>
        </Grid>
    </Grid>

            </Grid>
            {/* right side - preview */}
            <Grid item xs={6}>
            {selectedExercisesDetail.length != 0 ? (
                <Paper
                    elevation={3}
                    sx={{
                    maxHeight: 440,
                    overflow: 'auto',
                    p: 2,
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-start'
                    }}
                >
                    <SentenceTransformAttemptPreview questions={selectedExercisesDetail} />
                </Paper>
                ) : (
                    <Paper elevation={3}
                    sx={{minHeight: 95, 
                        padding:2, 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center'
                    }}>
                        <>Select exercise(s) to preview questions here.</>
                    </Paper>
                )}
            </Grid>

            {selectedExerciseDetails.length !== 0 && 
            <Grid item xs={12} style={{ display:'flex', textAlign: "center", justifyContent:'center', alignItems: 'center' }}>
                <Button className="app-btn-bg" sx={{
                    margin:'0 5px 22px 5px',
                    }}
                    onClick={handleStartClick} 
                    color="info" variant="contained" size="large"
                    >
                    START
                </Button>
            </Grid>
            }
        </Grid>
        </>
        }
        {
            viewMode=='START_REDO' &&
            <SentenceTransformQSetExercise isListLoaded={isListLoaded} oUser={oUser} submitDone={submitDone} redoExerciseList={selectedExerciseDetails}></SentenceTransformQSetExercise>
        }
      </Grid>
    )
}